import React, { useEffect, useState } from "react";
import { isWindows } from "react-device-detect";
import styled from "styled-components";
import LinkButton from "@common/LifeAtButton/Variants/LinkButton";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import useLocalStorage from "@hooks/useLocalStorage";
import { LocalStorageKeys } from "@service/LocalStorageService";

const StyledModal = styled(LifeAtModal)`
    z-index: 5800 !important;
`;

const CtaImg = styled.img`
    height: 60%;
    width: 75%;
`;

const CTA_IMG_URL_MAC =
    "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fonboarding%2FMenubarCta_Mac.png?alt=media&token=6dcf138f-7323-4421-a8a0-f56a84e3f219";
const CTA_IMG_URL_WINDOWS =
    "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fonboarding%2FMenubarCta_Windows.png?alt=media&token=9e9cd4ca-ab7d-4e6d-be56-59d872ada66d";

interface MenubarCtaModalProps {
    readonly onContinueCb: () => void;
}
function MenubarCtaModal(props: MenubarCtaModalProps) {
    const [hasSeenCta, setHasSeenCta] = useLocalStorage<boolean>(LocalStorageKeys.HasUserAcknowledgedMenubarCta, false);
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        if (!hasSeenCta) {
            const t = setTimeout(() => setShowModal(true), 500);
            return () => clearTimeout(t);
        } else {
            setShowModal(false);
            return undefined;
        }
    }, [hasSeenCta]);

    let appIconLocation;
    let ctaImgSrc;
    if (isWindows) {
        appIconLocation = "task bar";
        ctaImgSrc = CTA_IMG_URL_WINDOWS;
    } else {
        appIconLocation = "menubar";
        ctaImgSrc = CTA_IMG_URL_MAC;
    }

    return (
        window.todesktop &&
        showModal && (
            <StyledModal
                isOpen={showModal}
                closeModal={() => {}}
                title={`Last step: try clicking on the ${appIconLocation} icon for one-click access to your tasks and calendar`}
                centerContent={true}
                preventClose={true}
            >
                <CtaImg src={ctaImgSrc} />

                <LinkButton
                    label={"Continue"}
                    handleClick={() => {
                        setHasSeenCta(true);
                        props.onContinueCb();
                    }}
                />
            </StyledModal>
        )
    );
}

export default MenubarCtaModal;
